import React, { Component, FC } from 'react';
import styled from 'styled-components';
import { connectDeep } from 'redux-utils';

import { ModalContent } from '../StateManagementButton/types';
import { Content } from './ModalContent';
import { Portal } from '../Portal/index';
import { setModalShowing } from 'actions/gallery';

interface ModalProps extends ModalContent {
  onCancel: () => void;
}

const Container = styled.div`
  height: 100vh;
  position: absolute;
  top: 0;
  width: 100vw;
`;

export const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.4);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 65536;
`;

const Modal: FC<ModalProps> = ({ buttons, contentAbove, contentCenter, title, onCancel }) => (
  <Container>
    <Content
      buttons={buttons}
      contentAbove={contentAbove}
      contentCenter={contentCenter}
      title={title}
    />
    <Overlay onClick={onCancel} />
  </Container>
);

const mapDispatchToProps = (dispatch: any) => ({
  setModalShowing: (showing: boolean) => dispatch(setModalShowing(showing))
});

type ReduxProps = ReturnType<typeof mapDispatchToProps> & ModalProps & {
  id: string;
};

export default connectDeep(
  null,
  mapDispatchToProps
)(
  class extends Component<ReduxProps> {
    componentDidMount() {
      this.props.setModalShowing(true);
    }

    componentWillUnmount() {
      this.props.setModalShowing(false);
    }

    render() {
      const { id, ...modalProps } = this.props;

      return <Portal id={id} content={<Modal {...modalProps} />} />;
    }
  }
);